import { Breadcrumbs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '~/components/Tooltip';
import { useFolderPath } from '~/contexts';
import { BreadcrumbButton } from '../breadcrumbs/styles';
import { CurrentFolder } from './styles';

export interface FolderBreadcrumbsProps {
  allItems: () => void;
  label?: string;
  changeFolder: (id: number) => void;
  folder: { readonly id: number; readonly name: string };
  contentPage?: boolean;
}

export const FolderBreadcrumbs = ({
  allItems,
  label,
  changeFolder,
  folder,
  contentPage = false,
}: FolderBreadcrumbsProps) => {
  const { t } = useTranslation();
  const path = useFolderPath(folder.id);
  const defaultLabel = label || t('components.content_select.labels.all_items');

  return (
    <Breadcrumbs aria-label={t('common.navigation.breadcrumbs')}>
      {path.map((entry, index) => {
        const name = index === 0 ? defaultLabel : entry.name;
        return index === path.length - 1 && contentPage === false ? (
          <Tooltip key={entry.id} title={name}>
            <CurrentFolder>{name}</CurrentFolder>
          </Tooltip>
        ) : (
          <BreadcrumbButton
            key={entry.id}
            onClick={index === 0 ? allItems : () => changeFolder(entry.id)}
            variant="text"
          >
            {name}
          </BreadcrumbButton>
        );
      })}
    </Breadcrumbs>
  );
};
